import {
  UPDATE_COUNTRY_IS_FETCHING,
  UPDATE_COUNTRY_LIST,
  UPDATE_CATEGORY_IS_FETCHING,
  UPDATE_CATEGORY_LIST,
  UPDATE_PERMISSIONS_IS_FETCHING,
  UPDATE_PERMISSIONS_LIST
} from "../types";

const initialState = {
  country: { isFetching: false },
  category: { isFetching: false },
  permissions: { isFetching: false }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_COUNTRY_IS_FETCHING:
      return {
        ...state,
        country: {
          ...state.country,
          isFetching: action.isFetching
        }
      };
    case UPDATE_COUNTRY_LIST:
      return {
        ...state,
        country: {
          list: action.list,
          isFetching: false
        }
      };
    case UPDATE_CATEGORY_IS_FETCHING:
      return {
        ...state,
        category: {
          ...state.category,
          isFetching: action.isFetching
        }
      };
    case UPDATE_CATEGORY_LIST:
      return {
        ...state,
        category: {
          list: action.list,
          isFetching: false
        }
      };
    case UPDATE_PERMISSIONS_IS_FETCHING:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          isFetching: action.isFetching
        }
      };
    case UPDATE_PERMISSIONS_LIST:
      return {
        ...state,
        permissions: {
          list: action.list,
          isFetching: false
        }
      };
    default:
      return state;
  }
};
